//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import Layout from '@/components/Layout/Layout';
import { ERoutesRoot } from '@/routes/RoutesEnum';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Layout selectedMenuItem="None">
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', marginTop: 2, paddingBottom: 0 }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ marginBottom: 1 }}>
          {"Looks like you're lost!"}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          The page you are looking for is not available.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(ERoutesRoot.Dashboard)}
        >
          Go Home
        </Button>
      </Container>
    </Layout>
  );
}

export default NotFoundPage;
